import createDappAsyncThunk from "../asyncThunk"
import {
  setBorrowHistory,
  setBorrowLiquity,
  setCollateralPrice,
  setUserLoan,
} from "../slices/borrow"

export const fetchMusdCollateralPrice = createDappAsyncThunk(
  "borrow/fetchMusdCollateralPrice",
  async (_, { dispatch, extra: { sdk } }) => {
    const collateralPrice =
      await sdk.mezo.chain?.musdModule.fetchCollateralPrice()

    dispatch(setCollateralPrice(collateralPrice ?? 0n))
  },
)

export const borrowMusd = createDappAsyncThunk(
  "borrow/borrowMusd",
  async (
    { debtAmount, assetAmount }: { debtAmount: bigint; assetAmount: bigint },
    { extra: { sdk } },
  ) => {
    const borrowResult = await sdk.mezo.chain?.musdModule.borrow(
      debtAmount,
      assetAmount,
    )

    return !!borrowResult
  },
)

export const fetchMusdLiquityProps = createDappAsyncThunk(
  "borrow/fetchMusdLiquityProps",
  async (_, { dispatch, extra: { sdk } }) => {
    const liquity = await sdk.mezo.chain?.musdModule.getMusdLiquityProps()

    if (liquity) {
      dispatch(setBorrowLiquity(liquity))
    }
  },
)

export const fetchUserLoan = createDappAsyncThunk(
  "borrow/fetchUserLoan",
  async (_, { dispatch, extra: { sdk } }) => {
    const loan = await sdk.mezo.chain?.musdModule.getDebtForAddress()

    if (loan) {
      dispatch(setUserLoan(loan))
    }
  },
)

export const increaseDebt = createDappAsyncThunk(
  "borrow/increaseDebt",
  async (amount: bigint, { extra: { sdk } }) => {
    const result = await sdk.mezo.chain?.musdModule.increaseDebt(amount)

    return !!result
  },
)

export const increaseDebtAndCollateral = createDappAsyncThunk(
  "borrow/increaseDebtAndCollateral",
  async (
    {
      debtChange,
      collateralAmount,
    }: { debtChange: bigint; collateralAmount: bigint },
    { extra: { sdk } },
  ) => {
    const result = await sdk.mezo.chain?.musdModule.increaseDebtAndCollateral(
      debtChange,
      collateralAmount,
    )

    return !!result
  },
)

export const depositCollateral = createDappAsyncThunk(
  "borrow/depositCollateral",
  async (amount: bigint, { extra: { sdk } }) => {
    const result = await sdk.mezo.chain?.musdModule.depositCollateral(amount)

    return !!result
  },
)

export const withdrawCollateral = createDappAsyncThunk(
  "borrow/withdrawCollateral",
  async (amount: bigint, { extra: { sdk } }) => {
    const result = await sdk.mezo.chain?.musdModule.withdrawCollateral(amount)

    return !!result
  },
)

export const repayPartialDebt = createDappAsyncThunk(
  "borrow/repayPartialDebt",
  async (amount: bigint, { extra: { sdk } }) => {
    const result = await sdk.mezo.chain?.musdModule.repayPartialDebt(amount)
    return !!result
  },
)

export const repayDebtAndWithdrawCollateral = createDappAsyncThunk(
  "borrow/repayDebtAndWithdrawCollateral",
  async (
    {
      debtChange,
      collateralChange,
    }: { debtChange: bigint; collateralChange: bigint },
    { extra: { sdk } },
  ) => {
    const result =
      await sdk.mezo.chain?.musdModule.repayDebtAndWithdrawCollateral(
        debtChange,
        collateralChange,
      )

    return !!result
  },
)

export const closeLoan = createDappAsyncThunk(
  "borrow/closeLoan",
  async (_, { extra: { sdk } }) => {
    const result = await sdk.mezo.chain?.musdModule.closeLoan()

    return !!result
  },
)

export const fetchBorrowHistory = createDappAsyncThunk(
  "borrow/fetchBorrowHistory",
  async (_, { extra: { sdk }, dispatch }) => {
    const result = await sdk.mezo.api.borrow.getBorrowHistory()

    dispatch(setBorrowHistory(result))
  },
)
